import React, { FC, useEffect } from 'react';
import NetworkSelect from '@components/NetworkSelect';
import Icon from '@components/Icon';
import { Network } from '@types';
import staticConfig from '@config/static-config';
import useNetworkEnv from '@hooks/useNetworkEnv';
import useGetNetworkName from '@hooks/useGetNetworkName';
import { DropdownMenuOption } from './DropdownMenu';

const { networks } = staticConfig;
interface NetworkSelectionModuleProps {
  fromOnChange(v: Network): void;
  fromValue: Network;
  onFlipNetworks(): void;
  toOnChange(v: Network): void;
  toOnAutoChange(v: Network): void;
  toValue: Network;
}

const NetworkSelectionModule: FC<NetworkSelectionModuleProps> = ({
  fromOnChange,
  fromValue,
  onFlipNetworks,
  toOnChange,
  toOnAutoChange,
  toValue,
}) => {
  const [isTestnet] = useNetworkEnv();
  const getNetworkName = useGetNetworkName();
  const networksConfig = isTestnet ? networks.testnet : networks.mainnet;
  const fromNetworkOptions = Object.entries(networksConfig)
    .filter(([, { hide }]) => !hide)
    .map(([network, { disabled }]) => ({
      label:
        getNetworkName(network as Network) +
        (disabled
          ? network === Network.Terra
            ? ' - Paused'
            : ' - Coming Soon'
          : ''),
      value: network,
      disabled,
    })) as DropdownMenuOption[];
  const toNetworkOptions = Object.entries(
    networksConfig?.[fromValue]?.toNetworks || []
  )
    .filter(([, { hide }]) => !hide)
    .map(([network, { disabled }]) => ({
      label:
        getNetworkName(network as Network) +
        (disabled
          ? network === Network.Terra
            ? ' - Paused'
            : ' - Coming Soon'
          : ''),
      value: network,
      disabled,
    })) as DropdownMenuOption[];

  useEffect(() => {
    const toNetworks = toNetworkOptions
      .filter(({ disabled }) => !disabled)
      .map(({ value }) => value);
    if (!toNetworks?.includes(toValue)) {
      toOnAutoChange(toNetworks[0] || Network.Cronos);
    }
  }, [toNetworkOptions, toValue, toOnAutoChange]);

  return (
    <div className="flex items-center">
      <NetworkSelect
        className="flex-1"
        label="From"
        onChange={fromOnChange}
        options={fromNetworkOptions}
        value={fromValue}
      />
      <button
        className="flex justify-center items-center bg-darkGray rounded-small mx-2 tablet:mx-3 p-1"
        onClick={onFlipNetworks}
      >
        <Icon.Swap className="text-white text-iconMedium" />
      </button>
      <NetworkSelect
        className="flex-1"
        label="To"
        value={toValue}
        onChange={toOnChange}
        options={toNetworkOptions}
      />
    </div>
  );
};

export default NetworkSelectionModule;
